import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type {
    IUseRemoveWorkOrderObjectProps,
    IUseRemoveWorkOrderObjectResult,
} from 'pages/Project/Common/WorkOrderStructure/types';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerRemoveWorkOrderChangeObjectItemGql } from '../../WorkOrderChangeQueries';

const requestId = 'uerRemoveWorkOrderChangeObjectItem';

export const useUerRemoveWorkOrderChangeObject = (
    props: IUseRemoveWorkOrderObjectProps,
): IUseRemoveWorkOrderObjectResult => {
    const dispatch = useDispatch();
    const { onSuccess, workOrderOrChangeId } = props;

    const [uerRemoveWorkOrderChangeObjectItemReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerRemoveWorkOrderChangeObjectItemReset(undefined);
        onSuccess?.();
    }, [uerRemoveWorkOrderChangeObjectItemReset, onSuccess]);

    const [, uerRemoveWorkOrderChangeObjectItemStatus, , uerRemoveWorkOrderChangeObjectItemRequest] = useRequest({
        requestId,
        query: uerRemoveWorkOrderChangeObjectItemGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerRemoveWorkOrderChangeObjectItemMakeRequest = useCallback(
        (contractObjectId: number) => {
            dispatch(
                uerRemoveWorkOrderChangeObjectItemRequest({ workOrderChangeId: workOrderOrChangeId, contractObjectId }),
            );
        },
        [uerRemoveWorkOrderChangeObjectItemRequest, dispatch, workOrderOrChangeId],
    );

    useEffect(() => {
        uerRemoveWorkOrderChangeObjectItemReset(undefined);
    }, [uerRemoveWorkOrderChangeObjectItemReset]);

    return {
        status: uerRemoveWorkOrderChangeObjectItemStatus,
        makeRequest: uerRemoveWorkOrderChangeObjectItemMakeRequest,
    };
};
